import smoothScroll from 'smooth-scroll';
var options = { 
  speed: $(window).width() >= 1024 ? 80 : 300,
  offset: $(window).width() >= 1024 ? 0 : 50
};

var scroll = new smoothScroll('a[href*="#"]', options);



var target = location.hash;
// console.log(target);
var h = $('body').height();


if ($(target).length > 0) {
  $(window).scrollTop(0);
  setTimeout(function () {
    scroll.animateScroll(document.querySelector(target), options);
  }, 700);
  // $(window).on('scroll', function () {
  //   if (h != $('body').height()) {
  //     h = $('body').height();
  //     scroll.animateScroll(document.querySelector(target), options);
  //   }
  // })
}


//アンカーリンクの場合data-scrollをつける
// $("a[href*='#']").each(function () {
//   var href = $(this).attr('href');
//   if (href && href !== "#") {
//     var id = href.substring(href.indexOf("#"), href.length);
//     if (($(id).length)) {
//       // console.log(href)
//       $(this).attr('data-scroll', '');
//     }
//   }
// });
//data-scrollがついているものはスムーススクロール
// var scroll = new SmoothScroll('a[href*="#"]');
// smoothScroll.init({
//   speed: 500,
//   offset: $(window).width() >= 1024 ? 0 : 50
// });


//リンククリック時にhrefの#を取得
// var hash = false;
// $("a[href*='#']").on('click', function (e) {
//   console.log(e.target.closest('a').hash)
//   hash = e.target.closest('a').hash;
// })

// //
// $(window).on('scroll', function () {
//   if (hash) {
//     if (h != $('body').height()) {
//       h = $('body').height();
//       scroll.animateScroll(document.querySelector(hash), options);
//       // console.log(hash);
//     }
//   }
// })

$("a[href*='#']").on('click', function (e) {
  // console.log(e.target.closest('a').hash)
  target = e.target.closest('a').hash;
})

document.addEventListener('scrollStop', function () {
  var t = $(target).offset().top;
  var s = $(window).scrollTop();
  var a = t - s; 
  // hash = false;
  if (a > 100) {
    // console.log(a)
    // h = $('body').height();
    scroll.animateScroll(document.querySelector(target), options);
  }
  // console.log("s")
  setTimeout(function () {
    scroll.cancelScroll();
  }, 1000);
  
}, false);


